var map = {
	"./a-e_1.mp3": [
		7761,
		7761
	],
	"./a_1.mp3": [
		2886,
		2886
	],
	"./ai_1.mp3": [
		5981,
		5981
	],
	"./ar_1.mp3": [
		9063,
		9063
	],
	"./au_1.mp3": [
		8389,
		8389
	],
	"./aw_1.mp3": [
		9021,
		9021
	],
	"./ay_1.mp3": [
		4704,
		4704
	],
	"./b_1.mp3": [
		5619,
		5619
	],
	"./c_1.mp3": [
		5311,
		5311
	],
	"./ch_1.mp3": [
		4171,
		4171
	],
	"./ck_1.mp3": [
		8486,
		8486
	],
	"./d_1.mp3": [
		1595,
		1595
	],
	"./e-e_1.mp3": [
		8362,
		8362
	],
	"./e_1.mp3": [
		3424,
		3424
	],
	"./ea_1.mp3": [
		1387,
		1387
	],
	"./ear_1.mp3": [
		9665,
		9665
	],
	"./ee_1.mp3": [
		4843,
		4843
	],
	"./er_1.mp3": [
		4807,
		4807
	],
	"./ew_1.mp3": [
		7710,
		7710
	],
	"./ey_1.mp3": [
		7189,
		7189
	],
	"./f_1.mp3": [
		7992,
		7992
	],
	"./ff_1.mp3": [
		9716,
		9716
	],
	"./g_1.mp3": [
		5827,
		5827
	],
	"./h_1.mp3": [
		7319,
		7319
	],
	"./i-e_1.mp3": [
		9380,
		9380
	],
	"./i_1.mp3": [
		5169,
		5169
	],
	"./ie_1.mp3": [
		6379,
		6379
	],
	"./igh_1.mp3": [
		806,
		806
	],
	"./ir_1.mp3": [
		9162,
		9162
	],
	"./j_1.mp3": [
		4449,
		4449
	],
	"./k_1.mp3": [
		1945,
		1945
	],
	"./l_1.mp3": [
		8559,
		8559
	],
	"./ll_1.mp3": [
		5328,
		5328
	],
	"./m_1.mp3": [
		6614,
		6614
	],
	"./n_1.mp3": [
		1350,
		1350
	],
	"./ng_1.mp3": [
		5254,
		5254
	],
	"./o-e_1.mp3": [
		4359,
		4359
	],
	"./o_1.mp3": [
		2056,
		2056
	],
	"./oa_1.mp3": [
		1158,
		1158
	],
	"./oe_1.mp3": [
		934,
		934
	],
	"./oi_1.mp3": [
		4317,
		4317
	],
	"./oo_1.mp3": [
		4742,
		4742
	],
	"./oo_2.mp3": [
		5096,
		5096
	],
	"./or_1.mp3": [
		9501,
		9501
	],
	"./ou_1.mp3": [
		2500,
		2500
	],
	"./ow.mp3": [
		1952,
		1952
	],
	"./ow_2.mp3": [
		4409,
		4409
	],
	"./oy_1.mp3": [
		3404,
		3404
	],
	"./p_1.mp3": [
		5477,
		5477
	],
	"./ph_1.mp3": [
		8301,
		8301
	],
	"./qu_1.mp3": [
		723,
		723
	],
	"./r_1.mp3": [
		4020,
		4020
	],
	"./s_1.mp3": [
		1711,
		1711
	],
	"./sh_1.mp3": [
		9289,
		9289
	],
	"./ss_1.mp3": [
		1691,
		1691
	],
	"./t_1.mp3": [
		6998,
		6998
	],
	"./th_1.mp3": [
		4393,
		4393
	],
	"./u-e.mp3": [
		7023,
		7023
	],
	"./u-e_2.mp3": [
		8306,
		8306
	],
	"./u_1.mp3": [
		9053,
		9053
	],
	"./ur_1.mp3": [
		9028,
		9028
	],
	"./ure_1.mp3": [
		906,
		906
	],
	"./v_1.mp3": [
		2837,
		2837
	],
	"./w_1.mp3": [
		1270,
		1270
	],
	"./wh_1.mp3": [
		6856,
		6856
	],
	"./x_1.mp3": [
		9220,
		9220
	],
	"./y_1.mp3": [
		9661,
		9661
	],
	"./z_1.mp3": [
		7960,
		7960
	],
	"./zz_1.mp3": [
		3477,
		3477
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5674;
module.exports = webpackAsyncContext;